module.exports = __webpack_public_path__ + "img/phone.b40fb582.svg";